import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e619f5ba&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=e619f5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e619f5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e619f5ba')) {
      api.createRecord('e619f5ba', component.options)
    } else {
      api.reload('e619f5ba', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e619f5ba&scoped=true&", function () {
      api.rerender('e619f5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Third-service-fee/modules/table-list/detail.vue"
export default component.exports